/**
 * Costanti e helper centralizzati per i canali di assistenza Enermed.
 *
 * Vivono qui per evitare numeri hardcoded sparsi (PromozioniCarousel,
 * ProfilePage, SecuritySettingsPage, future feature).
 */

export const ENERMED_PHONE = '800616008'
export const ENERMED_WHATSAPP = '3896844227'

/**
 * Costruisce un URL `wa.me` con messaggio precompilato.
 */
export function whatsappUrl(message?: string): string {
  const base = `https://wa.me/${ENERMED_WHATSAPP}`
  if (!message) return base
  return `${base}?text=${encodeURIComponent(message)}`
}

/**
 * Messaggio precompilato per richiesta disattivazione/modifica MFA.
 * Aiuta il supporto a smistare velocemente la richiesta.
 */
export function buildMfaSupportMessage(input: {
  customerName?: string | null
  codiceCliente?: string | null
  preferredChannel?: string | null
}): string {
  const name = input.customerName?.trim() ?? ''
  const codice = input.codiceCliente?.trim() ?? ''
  const channel = input.preferredChannel ?? ''

  const intro = name ? `Salve, sono ${name}` : 'Salve'
  const codiceLine = codice ? `codice cliente ${codice}, ` : ''
  const channelLine = channel
    ? `Vorrei disattivare o cambiare il canale MFA (attualmente ${channel}).`
    : 'Vorrei informazioni sulla gestione dell’MFA del mio account.'

  return `${intro}, ${codiceLine}${channelLine}`
}
